export const Type = {
  Text: 0,
  Slider: 1,
  Select: 2,
};
